import React from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'
import { useCountryContext } from '@scentregroup/shared/context'

import style from './index.module.scss'

type Props = {
  className?: string
  showSearch: () => void
}

const SearchBar: React.FC<Props> = ({ className, showSearch }) => {
  const country = useCountryContext()
  const placeholder =
    country === 'New Zealand' ? 'Stores and more' : 'Stores, products and more'
  return (
    <div className={classNames(className, style.search)}>
      <button aria-label="Search" onClick={showSearch}>
        <Icon size="medium" type="search" className={classNames(style.icon)} />
      </button>
      <input
        className={style.searchInput}
        placeholder={placeholder}
        onClick={showSearch}
      />
    </div>
  )
}

export default SearchBar
